
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/feature/SEOHead';

export default function AboutPage() {
  const aboutSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "关于狮虎堂",
    "description": "了解狮虎堂的企业文化、发展历程和核心价值观。我们致力于传承中华养生智慧，为现代人提供优质的健康产品。",
    "url": `${import.meta.env.VITE_SITE_URL}/about`,
    "mainEntity": {
      "@type": "Organization",
      "name": "狮虎堂",
      "description": "中国狮虎堂中草药集团有限公司，融汇三地精粹，唤醒沉睡在你体内的原生力量。"
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="关于狮虎堂 - 传承中华养生智慧"
        description="了解狮虎堂的企业文化、发展历程和核心价值观。我们致力于传承中华养生智慧，为现代人提供优质的健康产品。"
        keywords="狮虎堂简介,企业文化,中华养生,健康理念,公司介绍"
        ogImage="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/f35a59635442fe291a9bbc6026c2854c.jfif"
        schema={aboutSchema}
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section 
          className="relative py-20 text-white bg-cover bg-top bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(47, 54, 115, 0.7), rgba(247, 147, 29, 0.7)), url('https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/72b44ca3bd195f98dc371a326ff0e324.jfif')`
          }}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">品牌故事</h1>
            <p className="text-base md:text-lg opacity-90 max-w-3xl mx-auto">
              一门匠心，三地淬炼的传奇之路
            </p>
          </div>
        </section>

        {/* Brand Story Content */}
        <section className="py-20 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="prose prose-lg max-w-none">
              <div className="text-center mb-16">
                <h2 className="text-xl md:text-2xl font-bold text-[#2f3673] mb-4">传承与创新的完美融合</h2>
                <div className="w-24 h-1 bg-[#f7931d] mx-auto"></div>
              </div>
              
              <div className="space-y-12 text-gray-700 leading-relaxed">
                <p className="text-sm md:text-base text-center">
                  <strong>中国狮虎堂中草药集团有限公司</strong>，立足香港，放眼全球。
                  我们深信，真正的男性养生，需融汇东方的智慧与世界的视野。
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 my-16">
                  <div className="relative h-80 rounded-2xl overflow-hidden group cursor-pointer">
                    <img
                      src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/489400cc69f32fbc10182a4ab2983487.png"
                      alt="香港总部"
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                    <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
                      <div className="w-12 h-12 bg-[#f7931d] rounded-full flex items-center justify-center mb-4">
                        <i className="ri-building-line text-white text-xl"></i>
                      </div>
                      <h3 className="text-base font-bold mb-2">香港总部</h3>
                      <p className="text-xs opacity-90">国际化标准与严苛品控</p>
                    </div>
                  </div>
                  
                  <div className="relative h-80 rounded-2xl overflow-hidden group cursor-pointer">
                    <img
                      src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/854ce886ff9b7a54deddd93ff81cbad3.jfif"
                      alt="云南道地药材"
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                    <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
                      <div className="w-12 h-12 bg-[#f7931d] rounded-full flex items-center justify-center mb-4">
                        <i className="ri-leaf-line text-white text-xl"></i>
                      </div>
                      <h3 className="text-base font-bold mb-2">云南道地药材</h3>
                      <p className="text-xs opacity-90">道地药材与传统工艺</p>
                    </div>
                  </div>
                  
                  <div className="relative h-80 rounded-2xl overflow-hidden group cursor-pointer">
                    <img
                      src="https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/61df7d4ac7046264f4e42bd72ce20d8d.jfif"
                      alt="泰国草本配方"
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                    <div className="absolute inset-0 flex flex-col justify-end p-6 text-white">
                      <div className="w-12 h-12 bg-[#f7931d] rounded-full flex items-center justify-center mb-4">
                        <i className="ri-sun-line text-white text-xl"></i>
                      </div>
                      <h3 className="text-base font-bold mb-2">泰国草本配方</h3>
                      <p className="text-xs opacity-90">热带活力与创新融合</p>
                    </div>
                  </div>
                </div>
                
                <p className="text-sm md:text-base">
                  在快节奏的现代生活中，男性承担着越来越多的责任与压力。
                  我们看到了这个群体的需求，也深深理解他们内心的渴望——
                  不是要成为超人，而是要保持本真的自己。
                </p>
                
                <p className="text-sm md:text-base">
                  狮虎堂的诞生，源于对传统中医智慧的敬畏，更源于对现代男性健康需求的深刻洞察。
                  我们相信，真正的养生不是简单的补充，而是唤醒身体内在的生命力。
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
